// 3. Pages/ResetPasswordPage.vue
<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
    <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow-lg">
      <div class="text-center">
        <h2 class="text-3xl font-bold text-gray-900 mb-2">Nouveau mot de passe</h2>
        <p class="text-gray-600">
          Créez un nouveau mot de passe sécurisé
        </p>
      </div>
      
      <form @submit.prevent="handleResetPassword" class="space-y-6">
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
            Nouveau mot de passe
          </label>
          <Password
            id="password"
            v-model="password"
            placeholder="Nouveau mot de passe"
            :feedback="true"
            toggleMask
            class="w-full"
            :class="{ 'p-invalid': errors.password }"
            required
          />
          <small v-if="errors.password" class="p-error">{{ errors.password }}</small>
        </div>
        
        <div>
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700 mb-2">
            Confirmer le mot de passe
          </label>
          <Password
            id="confirmPassword"
            v-model="confirmPassword"
            placeholder="Confirmer le mot de passe"
            :feedback="false"
            toggleMask
            class="w-full"
            :class="{ 'p-invalid': errors.confirmPassword }"
            required
          />
          <small v-if="errors.confirmPassword" class="p-error">{{ errors.confirmPassword }}</small>
        </div>
        
        <Button
          type="submit"
          label="Réinitialiser le mot de passe"
          class="w-full"
          :loading="loading"
        />
      </form>
      
      <div class="text-center">
        <router-link 
          to="/" 
          class="text-sm text-blue-600 hover:text-blue-500"
        >
          Retour à la connexion
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const errors = ref({})

const handleResetPassword = async () => {
  errors.value = {}
  
  if (!password.value) {
    errors.value.password = 'Mot de passe requis'
    return
  }
  
  if (password.value.length < 6) {
    errors.value.password = 'Le mot de passe doit contenir au moins 6 caractères'
    return
  }
  
  if (password.value !== confirmPassword.value) {
    errors.value.confirmPassword = 'Les mots de passe ne correspondent pas'
    return
  }
  
  loading.value = true
  
  try {
    // Simulation de réinitialisation
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    // Redirection vers la page de connexion
    router.push('/')
  } catch (error) {
    errors.value.general = 'Erreur lors de la réinitialisation'
  } finally {
    loading.value = false
  }
}
</script>
